// extracted by mini-css-extract-plugin
export default {"wrapper":"_8f3ddf5e","artTitle":"_4a80dd6a","artCreationDate":"_30487e57"};